module.exports = __webpack_public_path__ + "img/zhibo_red2.f0613960.png";